/**
 * Feedback Service
 * Submit satisfaction survey to POST /api/feedback
 */

import { apiService } from './api.service';
import { API_ENDPOINTS } from '@/config/api.config';
import type {
  SubmitFeedbackPayload,
  SubmitFeedbackResponse,
  AnonymousFeedbackItem,
} from '@/types/feedback';

export const feedbackService = {
  async submitFeedback(payload: SubmitFeedbackPayload): Promise<SubmitFeedbackResponse> {
    return apiService.post<SubmitFeedbackResponse>(
      API_ENDPOINTS.FEEDBACK.SUBMIT,
      payload
    );
  },

  async listAnonymousFeedback(): Promise<AnonymousFeedbackItem[]> {
    return apiService.get<AnonymousFeedbackItem[]>(API_ENDPOINTS.FEEDBACK.LIST);
  },
};
